import React from 'react';
import {Badge, Button, Card, Image} from "antd";

const NewCifraTovar = (props) => {
    return (
        <>
            <div style={{paddingRight: "20px", paddingTop: "20px"}}>

                    <Card
                        title={<Button href={props.mylink} style={{backgroundColor: "#382b2f"}} color="default" size={"large"}
                                       variant="solid" block>{props.catname}</Button>} bordered={false}
                        style={{backgroundColor: "#382b2f", textAlign: "center", width: 300}}>
                        <Image
                            width={250}
                            src={props.imgs}
                        />
                        <Button href={props.mylink} style={{marginTop: "20px", backgroundColor: "#000000"}}
                                color="default" size={"large"} variant="solid" block>Подробнее</Button>
                    </Card>
            </div>
        </>
    );
};

export default NewCifraTovar;